/**
 * Модуль для работы с платежами (покупка звёзд)
 */

import { logger } from "../../utils/logger.js";

/**
 * Создаёт менеджер для работы с платежами
 */
export function createPaymentScreenManager({
  getApiUrl,
  getTelegramWebApp,
  showScreen,
  documentRef = document,
}) {
  /**
   * Загружает список пакетов для покупки звёзд
   */
  async function loadPaymentPackages() {
    const domCache = window.__domCacheManager;
    const loadingManager = window.__loadingIndicatorManager;
    
    const container = domCache?.getCachedElement("#packages-list", documentRef) 
      || documentRef.getElementById("packages-list");
    
    if (!container) {
      return;
    }

    // Показываем skeleton loader
    if (loadingManager) {
      loadingManager.showLoading("payment-load", {
        target: container,
        type: "skeleton"
      });
    } else {
      const loadingHTML = '<div class="loading">Загрузка...</div>';
      domCache?.updateHTML("#packages-list", loadingHTML, documentRef) ||
      (container.innerHTML = loadingHTML);
    }

    try {
      const apiUrl = getApiUrl();
      const response = await fetch(`${apiUrl}/payments/packages`);
      const data = await response.json();

      if (data.success) {
        container.innerHTML = "";

        // Используем DocumentFragment для батчинга
        const fragment = documentRef.createDocumentFragment();
        data.packages.forEach((pkg) => {
          const item = documentRef.createElement("div");
          item.className = "gift-item";
          item.innerHTML = `
            <div style="font-weight: 600; font-size: 16px;">${pkg.description}</div>
            <div style="font-size: 14px; color: var(--tg-theme-hint-color); margin-top: 4px;">
              ${pkg.stars} ⭐
            </div>
            <div style="margin-top: 12px;">
              <button class="btn" onclick="if(typeof window.buyPackage === 'function') { window.buyPackage('${pkg.id}'); } else { console.error('buyPackage not defined'); }" style="width: 100%;">
                ${pkg.price} ₽
              </button>
            </div>
          `;
          fragment.appendChild(item);
        });
        container.appendChild(fragment);
      }
    } catch (error) {
      logger.error("Load payment packages error:", error);
      const errorHTML = '<div class="error">Ошибка загрузки пакетов</div>';
      domCache?.updateHTML("#packages-list", errorHTML, documentRef) ||
      (container.innerHTML = errorHTML);
    } finally {
      if (loadingManager) {
        loadingManager.hideLoading("payment-load");
      }
    }
  }

  /**
   * Показывает экран платежей
   */
  function showPaymentScreen() {
    showScreen("payment");
    try {
      loadPaymentPackages();
    } catch (error) {
      logger.warn("Не удалось загрузить пакеты звёзд:", error);
    }
  }

  /**
   * Обрабатывает покупку пакета звёзд
   */
  async function buyPackage(packageId) {
    const telegramWebApp = getTelegramWebApp();
    if (telegramWebApp?.showAlert) {
      telegramWebApp.showAlert(
        "Функция покупки звёзд будет доступна после настройки платежей",
      );
    }
  }

  return {
    loadPaymentPackages,
    showPaymentScreen,
    buyPackage,
  };
}














